import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const akf = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            'Partnerwerkstaetten in Ihrer Naehe': 'akf Auto-Leasing Partnerwerkstätten in Ihrer Nähe',
            layout: {
                backText: 'Zurück zu akf-servicelease.de'
            },
            linkToHome: 'https://werkstatt.repareo.de/partner/akf'
        },
    }
}
